import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";

import classes from "./modalSkeleton.module.css";
import { mergeClass } from "../../../resources/utils/helper";

export default function ModalSkeleton({
  size = "100",
  show,
  setShow,
  header,
  footer,
  children,
  modalClass,
  resetForm = () => {},
  hideHeaderBorder,
  headerStyles,
  borderRadius,
  showCloseIcon,
  width,
  borderLine = true,
  headerClass,
  modalStyles,
  headerHeading,
  className = "",
  isfaq = false,
  isEditing = false, // Adding default value isEditing
}) {
  const [isLoading, setIsLoading] = useState(false);

  function handleClose() {
    setShow(false);
    resetForm();
  }

  return (
    <>
      <Modal
        size={size}
        show={show}
        onHide={handleClose}
        centered
        className={`${[classes.modal, modalStyles].join(" ")}`}
      >
        {header && (
          <Modal.Header
            closeButton
            className={`${[classes.header, headerClass && headerClass].join(
              " "
            )}`}
            style={{ ...headerStyles }}
          >
            <h2 className={mergeClass("fw-700", headerHeading)}>{header}</h2>
          </Modal.Header>
        )}
        {showCloseIcon && (
          <div className={classes.iconBox} onClick={handleClose}>
            <AiOutlineClose size={16} className={classes.icon} />
          </div>
        )}
        <Modal.Body
          className={`${[
            isfaq ? classes.faq : classes.body,
            modalClass && modalClass,
          ].join(" ")}`}
        >
          {children}
        </Modal.Body>
      </Modal>
    </>
  );
}
